import type { CSSProperties } from 'react';
import type { ChartPoint } from '../ColumnChart/chart-point.ts';
import styles from './Chart.module.css';

const MAX_LABELS = 8;

export const positionOf = (index: number, count: number): number => (count <= 1 ? 0.5 : index / (count - 1));

export const centerOf = (index: number, count: number): number => (index + 0.5) / Math.max(count, 1);

const labelledEvery = (count: number): number => Math.max(Math.ceil(count / MAX_LABELS), 1);

const edgeOf = (index: number, count: number): string | undefined => {
  if (count <= 1) return undefined;
  if (index === 0) return 'start';
  if (index === count - 1) return 'end';
  return undefined;
};

export const BucketLabels = ({
  buckets,
  placeAt,
}: {
  buckets: readonly ChartPoint[];
  placeAt: (index: number, count: number) => number;
}) => {
  const every = labelledEvery(buckets.length);
  return (
    <div className={styles['buckets']} aria-hidden="true">
      {buckets.map((bucket, index) =>
        index % every === 0 ? (
          <span
            key={bucket.key}
            data-edge={placeAt === positionOf ? edgeOf(index, buckets.length) : undefined}
            data-minor={(index / every) % 2 === 1 ? true : undefined}
            style={{ '--chart-x': String(placeAt(index, buckets.length)) } as CSSProperties}
          >
            {bucket.label}
          </span>
        ) : null,
      )}
    </div>
  );
};
